import axiosClient from './axiosClient';
import { UserPreferences } from '../types'; // Assuming UserPreferences type is defined in types.ts

// --- Preferences API Calls ---

export const updatePreferencesApi = async (uid: string, preferences: Partial<UserPreferences>): Promise<UserPreferences> => {
  const response = await axiosClient.put(`/users/${uid}/preferences`, preferences);
  return response.data;
};
